import { createSelector } from 'reselect';

/**
 * Direct selector to the languageToggle state domain
 */
export const selectLanguage = (state) => state.get('language');

export const selectCwtTranslation = (state) => state.get();

export const cwtTranlationSelector = createSelector(
  selectLanguage,
  (cwtTranlationState) => cwtTranlationState.get('messages')
);

export const countrySelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('country')
);

export const languageSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('language')
);

export const pricingRulesSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('pricingRules')
);

export const currencySelector = createSelector(
  pricingRulesSelector,
  (pricing) => pricing.currencyCode
);

export const alternativeLanguagesSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('alternativeLanguages')
);

export const hasEcoPartSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('hasEcoPart')
);

export const ecoLinkURLSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('ecoLinkURL')
);

export const applicationSettingsSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('applicationSettings')
);

export const productServiceSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('productService')
);

export const translationsSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('translations')
);

export const localeSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('myLocale')
);

export const serviceSettingsSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('serviceSettings')
);

export const dexfSettingsSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('dexfSettings')
);

export const dataProviderSettingsSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('dataProviderSettings')
);

export const experienceGalleryBackURLSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('experienceGalleryBackURL')
);

export const upptackaIntegrationSelector = createSelector(
  selectLanguage,
  (languageState) => languageState.get('upptackaIntegration')
);
